import * as yup from 'yup';

export const passwordResetSchema = yup.object().shape({
  password: yup
    .string()
    .required()
    .matches(/^[a-zA-Z0-9]*$/, 'only_alphanumeric')
    .matches(/^(?=.*[0-9])([a-zA-Z0-9]+)$/, 'only_number')
    .matches(/^(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/, 'at_least_one_letter')
    .min(8, { key: 'min_length', value: 8 })
    .max(30, { key: 'max_length', value: 30 }),
  passwordConfirmation: yup
    .string()
    .required()
    .oneOf([yup.ref('password'), null], 'password_unmatched'),
});

export const defaultValuesPasswordResetForm = {
  password: '',
  passwordConfirmation: '',
};
